module.exports = __webpack_public_path__ + "img/user.f118b7ae.png";